export { Recommendations } from './Recommendations';
export type { RecommendationsProps, RecommendationItem } from './Recommendations.types';
